<div [ngClass]="disclaimerContainerClass">
    <img *ngIf="imageUrl" [src]="imageUrl" alt="" />

    <p class="legal-disclaimer__text">
        {{ DEFAULT_LEGAL_DISCLAIMER }}
        <a
            href="https://taap.mercer.com/Portals/0/content/Resource/terms-of-use.pdf"
            target="_blank"
            rel="Terms of Use"
            >Terms of Use</a
        >
    </p>
</div>
